import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import {useLocation} from 'react-router'
import {checkIsActive, KTSVG} from '../../../helpers'
import {useLayout, usePageData} from '../../core'
import { PAGE_PERMISSION } from '../../../../app/modules/roles/constant/role-default'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean,
  pagePermissions?: PAGE_PERMISSION[]
  activePaths?: string[]
}

const AsideMenuItemWithSub: React.FC<Props> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet,
  pagePermissions = [],
  activePaths = [],
}) => {
  const {pathname} = useLocation()
  const isActive = activePaths.length
    ? activePaths.some((path) => checkIsActive(pathname, path))
    : checkIsActive(pathname, to)
  const {config} = useLayout()
  const {aside} = config
  const [canView, setCanView] = useState(true);
  const { currentUser: { activePages } } = usePageData();

  useEffect(() => {

    if (pagePermissions.length > 0 && activePages) {
      const allowed = pagePermissions.some(page => activePages.some(activePage => activePage.name === page));
      setCanView(allowed);
    }

  }, [pagePermissions, activePages]);

  if (!canView)
    return <> </>;

  return (
    <div
      className={clsx('menu-item', {'here show': isActive}, 'menu-accordion')}
      data-kt-menu-trigger='click'
    >
      <span className='menu-link'>
        {hasBullet && (
          <span className='menu-bullet'>
            <span className='bullet bullet-dot'></span>
          </span>
        )}
        {icon && aside.menuIcon === 'svg' && (
          <span className='menu-icon'>
            <KTSVG path={icon} className='svg-icon-2' />
          </span>
        )}
        {fontIcon && aside.menuIcon === 'font' && <i className={clsx('bi fs-3', fontIcon)}></i>}
        <span className='menu-title'>{title}</span>
        <span className='menu-arrow'></span>
      </span>
      <div className={clsx('menu-sub menu-sub-accordion', {'menu-active-bg': isActive})}>
        {children}
      </div>
    </div>
  )
}

export {AsideMenuItemWithSub}
